import React from "react";
import { Form } from "semantic-ui-react";
import { connect } from "react-redux";
import { useFormContext } from "react-hook-form";

import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import { mapOfficerFormOptions } from "../../helpers/options/officerFormOptions";
import OfficerFormModalAction from "../../../redux/actions/OfficerFormModalAction";

const OfficerDetailsForm = (props) => {
  const {
    officerType,
    officerTypes,
    isEnforcementPolice,
    loadingOfficerTypes,
  } = props.data;
  const methods = useFormContext();
  const {
    register,
    control,
    formState: { errors },
  } = methods;
  let fields = mapOfficerFormOptions({ officerType, errors });

  return (
    <>
      {officerTypes && (
        <SelectComponent
          name="officerType"
          label="Officer Type"
          placeholder="Select type of officer"
          control={control}
          error={errors.officerType}
          options={officerTypes}
          loading={loadingOfficerTypes}
        />
      )}
      {fields.officerForm.map((x) => (
        <InputComponent
          key={x.key}
          name={x.name}
          label={x.label}
          labelClass="w-50"
          placeholder={x.placeholder}
          register={register}
          error={x.error}
        />
      ))}
      <Form.Field className="flex-between flex-row">
        <label className="w-50">
          {isEnforcementPolice ? "Police Station Address" : "Work Address"}
        </label>
        <div className="w-100">
          {fields.addressForm.map((x) => (
            <InputComponent
              key={x.key}
              name={x.name}
              label={x.label}
              placeholder={x.placeholder}
              register={register}
              error={x.error}
            />
          ))}
        </div>
      </Form.Field>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    data: OfficerFormModalAction.getStatePath(state),
  };
};

export default connect(mapStateToProps)(OfficerDetailsForm);
